var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAds3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 58,
    viewBox: "0 0 59 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "advertising_4672223 1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 58,
    height: 58,
    transform: "translate(0.5)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M51.8737 11.3945H7.1308C6.19686 11.3945 5.30117 11.7655 4.64078 12.4259C3.98038 13.0863 3.60938 13.982 3.60938 14.916V43.0874C3.60938 44.0213 3.98038 44.917 4.64078 45.5774C5.30117 46.2378 6.19686 46.6088 7.1308 46.6088H51.8737C52.8076 46.6088 53.7033 46.2378 54.3637 45.5774C55.0241 44.917 55.3951 44.0213 55.3951 43.0874V14.916C55.3951 13.982 55.0241 13.0863 54.3637 12.4259C53.7033 11.7655 52.8076 11.3945 51.8737 11.3945ZM49.1808 13.466V44.5374H11.8951V13.466H49.1808ZM5.6808 43.0874V14.916C5.6808 14.5314 5.83357 14.1626 6.1055 13.8907C6.37743 13.6187 6.74624 13.466 7.1308 13.466H9.82366V44.5374H7.1308C6.74624 44.5374 6.37743 44.3846 6.1055 44.1127C5.83357 43.8408 5.6808 43.472 5.6808 43.0874ZM53.3237 43.0874C53.3237 43.472 53.1709 43.8408 52.899 44.1127C52.627 44.3846 52.2582 44.5374 51.8737 44.5374H51.2522V13.466H51.8737C52.2582 13.466 52.627 13.6187 52.899 13.8907C53.1709 14.1626 53.3237 14.5314 53.3237 14.916V43.0874Z",
    fill: "url(#paint0_linear_1461_14201)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M21.2164 30.0366C21.4911 30.0366 21.7546 29.9275 21.9488 29.7333C22.143 29.539 22.2522 29.2756 22.2522 29.0009V27.7063H27.1718V29.0009C27.1718 29.2756 27.2809 29.539 27.4751 29.7333C27.6694 29.9275 27.9328 30.0366 28.2075 30.0366C28.4822 30.0366 28.7456 29.9275 28.9399 29.7333C29.1341 29.539 29.2432 29.2756 29.2432 29.0009V23.176C29.2561 22.5728 29.1485 21.9731 28.9265 21.4121C28.7046 20.851 28.3729 20.34 27.9509 19.9088C27.5288 19.4776 27.0249 19.1351 26.4688 18.9012C25.9126 18.6673 25.3153 18.5469 24.712 18.5469C24.1086 18.5469 23.5114 18.6673 22.9552 18.9012C22.399 19.1351 21.8951 19.4776 21.4731 19.9088C21.051 20.34 20.7193 20.851 20.4974 21.4121C20.2755 21.9731 20.1678 22.5728 20.1807 23.176V29.0009C20.1807 29.2756 20.2898 29.539 20.4841 29.7333C20.6783 29.9275 20.9417 30.0366 21.2164 30.0366ZM24.713 20.7152C25.3653 20.7157 25.9907 20.9753 26.4518 21.4367C26.9128 21.8981 27.1718 22.5237 27.1718 23.176V25.6348H22.2522V23.176C22.2522 22.5234 22.5114 21.8975 22.9729 21.436C23.4344 20.9745 24.0603 20.7152 24.713 20.7152Z",
    fill: "url(#paint1_linear_1461_14201)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M32.8717 30.0374H35.202C36.7128 30.0374 38.1617 29.4372 39.23 28.3689C40.2983 27.3007 40.8984 25.8517 40.8984 24.341C40.8984 22.8302 40.2983 21.3813 39.23 20.313C38.1617 19.2447 36.7128 18.6445 35.202 18.6445H32.8717C32.597 18.6445 32.3335 18.7537 32.1393 18.9479C31.9451 19.1421 31.8359 19.4056 31.8359 19.6802V29.0017C31.8359 29.2764 31.9451 29.5398 32.1393 29.734C32.3335 29.9283 32.597 30.0374 32.8717 30.0374ZM33.9074 20.716H35.202C36.1634 20.716 37.0855 21.0979 37.7653 21.7777C38.4451 22.4575 38.827 23.3795 38.827 24.341C38.827 25.3024 38.4451 26.2244 37.7653 26.9042C37.0855 27.584 36.1634 27.966 35.202 27.966H33.9074V20.716Z",
    fill: "url(#paint2_linear_1461_14201)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M17.0748 38.3235H34.8725C35.0834 38.9289 35.4775 39.4537 36.0001 39.8251C36.5227 40.1964 37.148 40.3959 37.7891 40.3959C38.4302 40.3959 39.0554 40.1964 39.578 39.8251C40.1006 39.4537 40.4947 38.9289 40.7056 38.3235H44.0033C44.278 38.3235 44.5415 38.2144 44.7357 38.0202C44.9299 37.8259 45.0391 37.5625 45.0391 37.2878C45.0391 37.0131 44.9299 36.7497 44.7357 36.5554C44.5415 36.3612 44.278 36.2521 44.0033 36.2521H40.7056C40.4947 35.6467 40.1006 35.1219 39.578 34.7505C39.0554 34.3792 38.4302 34.1797 37.7891 34.1797C37.148 34.1797 36.5227 34.3792 36.0001 34.7505C35.4775 35.1219 35.0834 35.6467 34.8725 36.2521H17.0748C16.8001 36.2521 16.5367 36.3612 16.3424 36.5554C16.1482 36.7497 16.0391 37.0131 16.0391 37.2878C16.0391 37.5625 16.1482 37.8259 16.3424 38.0202C16.5367 38.2144 16.8001 38.3235 17.0748 38.3235ZM37.7891 36.2521C37.9939 36.2521 38.1942 36.3128 38.3645 36.4266C38.5348 36.5405 38.6675 36.7022 38.7459 36.8915C38.8243 37.0807 38.8448 37.289 38.8049 37.4899C38.7649 37.6908 38.6663 37.8753 38.5214 38.0202C38.3766 38.165 38.192 38.2637 37.9911 38.3036C37.7902 38.3436 37.582 38.3231 37.3927 38.2447C37.2035 38.1663 37.0417 38.0335 36.9279 37.8632C36.8141 37.6929 36.7533 37.4927 36.7533 37.2878C36.7533 37.0131 36.8625 36.7497 37.0567 36.5554C37.2509 36.3612 37.5144 36.2521 37.7891 36.2521Z",
    fill: "url(#paint3_linear_1461_14201)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1461_14201",
    x1: -4.21855,
    y1: 64.4086,
    x2: 55.4655,
    y2: 1.7396,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF33B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#FEE72E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.117,
    stopColor: "#FED51B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.196,
    stopColor: "#FDCA10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.281,
    stopColor: "#FDC70C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.669,
    stopColor: "#F3903F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#ED683C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E93E3A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1461_14201",
    x1: -8.53342,
    y1: 60.2981,
    x2: 51.1507,
    y2: -2.36881,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF33B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#FEE72E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.117,
    stopColor: "#FED51B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.196,
    stopColor: "#FDCA10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.281,
    stopColor: "#FDC70C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.669,
    stopColor: "#F3903F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#ED683C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E93E3A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1461_14201",
    x1: -3.64349,
    y1: 64.9534,
    x2: 56.0406,
    y2: 2.28439,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF33B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#FEE72E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.117,
    stopColor: "#FED51B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.196,
    stopColor: "#FDCA10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.281,
    stopColor: "#FDC70C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.669,
    stopColor: "#F3903F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#ED683C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E93E3A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1461_14201",
    x1: 0.463991,
    y1: 68.8667,
    x2: 60.1481,
    y2: 6.19982,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF33B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#FEE72E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.117,
    stopColor: "#FED51B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.196,
    stopColor: "#FDCA10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.281,
    stopColor: "#FDC70C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.669,
    stopColor: "#F3903F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#ED683C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E93E3A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAds3);
export default __webpack_public_path__ + "static/media/ads3.9b1e7fda9e4cc6275bd047e474f80c60.svg";
export { ForwardRef as ReactComponent };